module.exports = __webpack_public_path__ + "img/sp-1.d9ff7d1d.png";